import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { DisableRecurrenceModalComponent } from './disable-recurrence-modal.component';

@NgModule({
  declarations: [DisableRecurrenceModalComponent],
  imports: [
    CommonModule,
    ButtonModule,
    ReactiveFormsModule,
    InputTextModule,
    DialogModule
  ],
  exports: [DisableRecurrenceModalComponent]
})
export class DisableRecurrenceModalModule {}
